<template>
  <section class="c-section c-section--politics">
    <b-skeleton-wrapper :loading="contextLoading">
      <template #loading>
          <b-card class="p-0">
            <div class="container-fluid p-0">
              <div style="height:400px">
                <div class="w-100 d-flex justify-content-center">
                  <b-skeleton-img no-aspect width="100%" height="300px"></b-skeleton-img>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="d-flex justify-content-center">
                <b-col cols="10">
                  <b-skeleton-img height="500px"></b-skeleton-img>
                </b-col>
              </div>
            </div>
          </b-card>
      </template>
      <div v-if="context.post" class="c-banner-top c-banner-top--black">
        <div class="c-banner-top__gradient"></div>
        <div class="container position-relative h-100">
          <figure class="c-banner-top__semiluna">
            <img
              src="@/assets/images/semiluna.png"
              alt=""
              class="w-100 of--contain d-none d-md-block"
            >
          </figure>
          <div class="c-banner-top__contain">
            <div>
              <h2 class="white fs-50 w-black mb-0">
                {{context.post.post_title}}
              </h2>
              <div class="d-flex">
                <router-link to="/" class="c-banner-top__link">
                  Inicio
                </router-link>
                <span class="mx-1 white fs-16 w-medium">/</span>
                <p class="white fs-16 w-medium mb-0">
                  {{context.post.post_title}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="context.post" class="c-politics">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 col-md-10">
              <div
                v-html="context.post.post_content"
                class="sec-alt fs-16 w-medium line-height mb-0 text-start test-lg-center">
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-skeleton-wrapper>
  </section>
</template>
<script>
export default {
  data() {
    return {
      test: null,
      context: {},
      contextLoading: true,
    };
  },
  created() {
    this.getFullContext({ type: 'page', slug: 'politicas' });
  },
  mounted() {
  },
};
</script>
